/* LUNEVVO product page: hero, sticky bar and recommendations */
(function () {
  const root = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function formatMoney(cents, format) {
    const fallback = '£' + String.fromCharCode(123, 123) + 'amount' + String.fromCharCode(125, 125);
    const fmt = (n, decimals, thousands, decimal) => {
      const parts = (n / 100).toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    };
    return (format || fallback).replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => {
      switch (key) {
        case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        default: return fmt(cents, 2, ',', '.');
      }
    });
  }

  /* Adds to cart, then opens the theme's cart drawer with fresh contents (or goes to /cart). */
  async function addToCart(body, opener) {
    const res = await fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body
    });
    const json = await res.json();
    if (!res.ok) throw new Error(json.description || json.message || 'Could not add to bag');

    const drawer = document.querySelector('cart-drawer');
    const useDrawer = drawer && window.theme && theme.settings && theme.settings.cartType === 'drawer';
    if (!useDrawer) {
      window.location.href = (window.theme && theme.routes && theme.routes.cart) || root() + 'cart';
      return json;
    }
    const cartForm = drawer.querySelector('cart-form');
    try {
      if (cartForm && cartForm.sectionId && typeof cartForm.refreshFromHtml === 'function') {
        const html = await fetch(root() + '?section_id=' + cartForm.sectionId).then((r) => r.text());
        cartForm.refreshFromHtml(html);
      } else if (cartForm && typeof cartForm.refresh === 'function') {
        cartForm.refresh();
      }
    } catch (e) { /* drawer refresh is best effort */ }
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { detail: { opener } }));
    return json;
  }

  /* ================= HERO ================= */
  if (!customElements.get('lunevvo-product-hero')) {
    class LunevvoProductHero extends HTMLElement {
      connectedCallback() {
        this.data = JSON.parse(this.querySelector('[data-hero-data]').textContent);
        this.form = this.querySelector('[data-hero-form]');
        this.idInput = this.querySelector('[data-variant-id]');
        this.fieldsets = Array.from(this.querySelectorAll('.lh-option'));
        this.gallery = this.querySelector('[data-gallery]');
        this.atc = this.querySelector('[data-atc]');
        this.sticky = this.querySelector('[data-sticky]');

        this.fieldsets.forEach((fs) => fs.addEventListener('change', () => {
          fs.classList.remove('lh-option--error');
          this.update(true);
        }));
        if (this.form) this.form.addEventListener('submit', (e) => this.onSubmit(e));
        const dynamic = this.querySelector('.lh-dynamic');
        if (dynamic) {
          dynamic.addEventListener('click', (e) => {
            if (this.missing && this.missing.length) {
              e.preventDefault();
              e.stopPropagation();
              this.promptMissing();
            }
          }, true);
        }
        this.setupGalleryCounter();
        this.setupSticky();
        this.update(false);
      }

      selectedOptions() {
        return this.fieldsets.map((fs) => {
          const checked = fs.querySelector('input:checked');
          return checked ? checked.value : null;
        });
      }

      findVariant(options) {
        if (options.some((o) => o === null)) return null;
        return this.data.variants.find((v) => v.options.every((o, i) => o === options[i])) || null;
      }

      anyAvailable(options) {
        return this.data.variants.some((v) => v.available && v.options.every((o, i) => options[i] === null || o === options[i]));
      }

      update(userChange) {
        const options = this.selectedOptions();
        this.missing = this.fieldsets.filter((fs, i) => options[i] === null);
        const variant = this.fieldsets.length ? this.findVariant(options) : this.data.variants[0];
        this.variant = variant;

        this.fieldsets.forEach((fs, i) => {
          const label = fs.querySelector('[data-selected-label]');
          if (label) label.textContent = options[i] || '';
          fs.querySelectorAll('input').forEach((input) => {
            const test = options.slice();
            test[i] = input.value;
            if (this.anyAvailable(test)) input.removeAttribute('data-unavailable');
            else input.setAttribute('data-unavailable', '');
          });
        });

        this.render(variant);
        if (variant) {
          this.idInput.value = variant.id;
          if (userChange) {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', url.toString());
          }
        }
        if (userChange) {
          const colorIndex = this.fieldsets.findIndex((fs) => fs.dataset.isColor === 'true');
          const mediaVariant = variant || (colorIndex > -1 && options[colorIndex]
            ? this.data.variants.find((v) => v.options[colorIndex] === options[colorIndex] && v.mediaId)
            : null);
          if (mediaVariant && mediaVariant.mediaId) this.showMedia(mediaVariant.mediaId);
        }
      }

      render(variant) {
        const $ = (s) => this.querySelector(s);
        const stock = $('[data-stock]');
        const stockText = $('[data-stock-text]');
        const atcText = $('[data-atc-text]');
        const stickyBtn = $('[data-sticky-btn]');
        const stickyVariant = $('[data-sticky-variant]');
        $('[data-error]').textContent = '';
        this.toggleAttribute('data-missing', this.missing.length > 0);
        const dyn = this.querySelector('.lh-dynamic');
        if (dyn) dyn.style.opacity = this.missing.length ? '0.45' : '';

        if (this.missing.length) {
          const name = this.missing[0].dataset.optionName.toLowerCase();
          this.atc.disabled = false;
          atcText.textContent = 'Select a ' + name;
          stock.dataset.state = 'none';
          stockText.textContent = '';
          if (stickyBtn) { stickyBtn.disabled = false; stickyBtn.textContent = 'Select ' + name; }
          if (stickyVariant) stickyVariant.textContent = this.selectedOptions().filter(Boolean).join(' / ');
          return;
        }

        if (!variant) {
          this.atc.disabled = true;
          atcText.textContent = 'Unavailable';
          stock.dataset.state = 'out';
          stockText.textContent = 'This combination isn’t available';
          if (stickyBtn) { stickyBtn.disabled = true; stickyBtn.textContent = 'Unavailable'; }
          return;
        }

        const price = formatMoney(variant.price, this.data.moneyFormat);
        $('[data-price-current]').textContent = price;
        const onSale = variant.compareAtPrice > variant.price;
        const compare = $('[data-price-compare]');
        const save = $('[data-price-save]');
        compare.hidden = !onSale;
        save.hidden = !onSale;
        if (onSale) {
          compare.textContent = formatMoney(variant.compareAtPrice, this.data.moneyFormat);
          save.textContent = 'Save ' + formatMoney(variant.compareAtPrice - variant.price, this.data.moneyFormat);
        }

        this.atc.disabled = !variant.available;
        atcText.textContent = variant.available ? this.data.buttonLabel : 'Sold out';
        if (stickyBtn) { stickyBtn.disabled = !variant.available; stickyBtn.textContent = variant.available ? this.data.buttonLabel : 'Sold out'; }
        const stickyPrice = $('[data-sticky-price]');
        if (stickyPrice) stickyPrice.textContent = price;
        if (stickyVariant) stickyVariant.textContent = variant.options.join(' / ');

        if (!variant.available) {
          stock.dataset.state = 'out';
          stockText.textContent = 'Sold out in this size';
        } else if (variant.low) {
          stock.dataset.state = 'low';
          stockText.textContent = 'Only ' + variant.low + ' left in this size';
        } else {
          stock.dataset.state = 'in';
          stockText.textContent = 'In stock, ready to ship';
        }
      }

      promptMissing() {
        const fs = this.missing[0];
        if (!fs) return;
        fs.classList.add('lh-option--error');
        const top = fs.getBoundingClientRect().top + window.scrollY - (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--theme-header-height'), 10) || 80) - 24;
        window.scrollTo({ top, behavior: 'smooth' });
        const first = fs.querySelector('input:not([data-unavailable])') || fs.querySelector('input');
        if (first) setTimeout(() => first.focus({ preventScroll: true }), 400);
      }

      showMedia(mediaId) {
        const target = this.querySelector('[data-media-id="' + mediaId + '"]');
        if (!target || !this.gallery) return;
        if (window.matchMedia('(min-width: 990px)').matches) {
          const top = target.getBoundingClientRect().top + window.scrollY - 120;
          if (Math.abs(target.getBoundingClientRect().top) > window.innerHeight) window.scrollTo({ top, behavior: 'smooth' });
        } else {
          this.gallery.scrollTo({ left: target.offsetLeft - this.gallery.offsetLeft, behavior: 'smooth' });
        }
      }

      setupGalleryCounter() {
        const indexEl = this.querySelector('[data-gallery-index]');
        if (!indexEl || !this.gallery) return;
        this.gallery.addEventListener('scroll', () => {
          indexEl.textContent = Math.round(this.gallery.scrollLeft / this.gallery.clientWidth) + 1;
        }, { passive: true });
      }

      setupSticky() {
        if (!this.sticky || !this.atc || !('IntersectionObserver' in window)) return;
        const btn = this.querySelector('[data-sticky-btn]');
        const io = new IntersectionObserver(([entry]) => {
          const past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.sticky.classList.toggle('is-visible', past);
          this.sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
        });
        io.observe(this.atc);
        btn.addEventListener('click', () => {
          if (this.missing.length) { this.promptMissing(); return; }
          this.submit(btn);
        });
      }

      onSubmit(event) {
        event.preventDefault();
        if (this.missing.length) { this.promptMissing(); return; }
        this.submit(this.atc);
      }

      async submit(opener) {
        if (!this.variant || !this.variant.available) return;
        const errorEl = this.querySelector('[data-error]');
        opener.setAttribute('aria-busy', 'true');
        errorEl.textContent = '';
        try {
          await addToCart(new FormData(this.form), opener);
        } catch (err) {
          errorEl.textContent = err.message;
        } finally {
          opener.removeAttribute('aria-busy');
        }
      }
    }
    customElements.define('lunevvo-product-hero', LunevvoProductHero);
  }

  /* ================= RECOMMENDATIONS ================= */
  if (!customElements.get('lunevvo-recommendations')) {
    class LunevvoRecommendations extends HTMLElement {
      connectedCallback() {
        if (this.querySelector('[data-recs-track]')) { this.init(); return; }
        const load = () => {
          fetch(this.dataset.url)
            .then((r) => r.text())
            .then((text) => {
              const doc = new DOMParser().parseFromString(text, 'text/html');
              const fresh = doc.querySelector('lunevvo-recommendations');
              if (fresh && fresh.querySelector('[data-recs-track]')) {
                this.innerHTML = fresh.innerHTML;
                this.init();
              }
            })
            .catch(() => {});
        };
        if ('IntersectionObserver' in window) {
          const io = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) { io.disconnect(); load(); }
          }, { rootMargin: '0px 0px 600px 0px' });
          io.observe(this);
        } else {
          load();
        }
      }

      init() {
        this.classList.add('is-loaded');
        this.track = this.querySelector('[data-recs-track]');
        const prev = this.querySelector('[data-recs-prev]');
        const next = this.querySelector('[data-recs-next]');
        const step = () => {
          const card = this.track.querySelector('.lrc-card');
          return card ? (card.getBoundingClientRect().width + 6) * 2 : this.track.clientWidth;
        };
        const sync = () => {
          if (!prev || !next) return;
          prev.disabled = this.track.scrollLeft <= 2;
          next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
        };
        if (prev) prev.addEventListener('click', () => this.track.scrollBy({ left: -step(), behavior: 'smooth' }));
        if (next) next.addEventListener('click', () => this.track.scrollBy({ left: step(), behavior: 'smooth' }));
        this.track.addEventListener('scroll', sync, { passive: true });
        sync();

        this.querySelectorAll('.lrc-card').forEach((card) => {
          const toggle = card.querySelector('[data-quick]');
          if (!toggle) return;
          toggle.addEventListener('click', () => {
            if (toggle.dataset.directId) { this.add(card, toggle.dataset.directId, toggle); return; }
            const open = !card.classList.contains('is-open');
            this.querySelectorAll('.lrc-card.is-open').forEach((c) => c.classList.remove('is-open'));
            card.classList.toggle('is-open', open);
            toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          });
          card.querySelectorAll('[data-add-id]').forEach((btn) => {
            btn.addEventListener('click', () => this.add(card, btn.dataset.addId, btn));
          });
        });
      }

      async add(card, id, opener) {
        const msg = card.querySelector('[data-quick-msg]');
        if (msg) msg.textContent = '';
        opener.setAttribute('aria-busy', 'true');
        const body = new FormData();
        body.append('id', id);
        body.append('quantity', '1');
        try {
          await addToCart(body, opener);
          card.classList.remove('is-open');
        } catch (err) {
          if (msg) msg.textContent = err.message;
          card.classList.add('is-open');
        } finally {
          opener.removeAttribute('aria-busy');
        }
      }
    }
    customElements.define('lunevvo-recommendations', LunevvoRecommendations);
  }
})();
